import React from "react";

import NavBarNew from "./NavBarNew";
import HeroSection from "./HeroSection";
import "./LandingPageHomeNew.css";
import CurvedLine from "./CurvedLine";
import WhoWeServe from "./WhoWeServe";
import Footer from "./footer";

const LandingPageHomeNew = () => {
  // const handleRedirect = () => {
  //   window.open("https://neuro42.ai/", "_blank");
  // };
  const handleRedirectProvider = () => {
    window.open("https://www.neuro42health.com/physicians", "_blank");
  };
  const handleRedirectPatient = () => {
    window.open("https://www.neuro42health.com/patients", "_blank");
  };
  return (
    <div className="main-page">
      <NavBarNew />
      <HeroSection />

      <div className="shapes">
        <div className="shape rectangle"></div>
        <div className="shape circle"></div>
      </div>

      <div className="styled-line-main">
        <div className="line1-main"></div>
        <div className="line2-main"></div>
        <div className="line3-main"></div>
      </div>

      <div className="info-section">
        <div className="info-content">
          <h2>
            Access Your MRI Scans Anytime – Simplifying Care for Patients and
            Providers
          </h2>
          <p>
            Welcome to neuro42 Health, the ultimate digital solution for
            managing and viewing portable MRI scans. Our platform ensures
            seamless access to your medical imaging, empowering patients and
            providers with secure, fast, and accurate tools for diagnostics and
            care. Experience the future of healthcare with a portal designed to
            enhance efficiency, reduce operational costs, and improve patient
            outcomes.
          </p>
          <div className="second-section-learn-more">
            <button
              className="learn-more-button"
              onClick={handleRedirectProvider}
            >
              Discover Provider Benefits
            </button>
            <button
              className="learn-more-button"
              onClick={handleRedirectPatient}
            >
              Discover Patient Benefits
            </button>
          </div>
        </div>
        {/* <div className="info-image">
          <img src={logo} alt="MRI Device" />
        </div> */}
      </div>

      <div className="shapes-2">
        <div className="rectangle2">
          <div className="telehealth-header">
            <div className="styled-line-TeleHealth">
              <div className="line1-TeleHealth"></div>
              <div className="line2-TeleHealth"></div>
              <div className="line3-TeleHealth"></div>
            </div>
            <h2>Health Portal Benefits</h2>
            <p>
              Transform the way you deliver care with our comprehensive health
              portal. Experience the future of healthcare today.
            </p>
          </div>
        </div>
      </div>
      <div className="curved-line-container">
        <CurvedLine />
      </div>
      <div className="WhoWeServe-container">
        <WhoWeServe />
      </div>

      <Footer />
    </div>
  );
};

export default LandingPageHomeNew;
